import React, { useEffect, useState } from 'react'
import { ReactComponent as ShieldAltSolid } from '../../resources/images/shield-alt-solid.svg'
import { getPrivacyURL } from '../../redux/actions/dashboard'
import { isEmpty } from 'lodash-es'

export default function PDPAInfo({ termsUrl }) {
  const [privacyUrl, setPrivacyUrl] = useState()

  useEffect(() => {
    let privacy_url = sessionStorage.getItem('privacy_notice')
    if (isEmpty(privacy_url)) {
      handelPrivacyURL()
    } else {
      setPrivacyUrl(privacy_url)
    }
  }, [])

  const handelPrivacyURL = async () => {
    try {
      const response = await getPrivacyURL()
      if (response) {
        sessionStorage.setItem('privacy_notice', response)
        setPrivacyUrl(response)
      }
    } catch (e) {}
  }

  return (
    <div style={Styles.main}>
      <div style={{ paddingLeft: 5, paddingRight: 10 }}>
        <ShieldAltSolid
          width={15}
          height={15}
          style={{ verticalAlign: 'middle', color: 'white' }}
        />{' '}
        <a href={privacyUrl || ''} target="_blank" style={Styles.aLink}>
          privacy
        </a>
        <span
          aria-hidden="true"
          role="presentation"
          style={{ marginLeft: '5px', marginRight: '5px', ...Styles.aLink }}
        >
          -
        </span>
        <a href={termsUrl} target="_blank" style={Styles.aLink}>
          terms
        </a>
      </div>
    </div>
  )
}

const Styles = {
  main: {
    zIndex: 9,
    position: 'fixed',
    right: 0,
    bottom: 0,
    backgroundColor: '#2da888',
    borderTopLeftRadius: 5,
  },
  aLink: {
    color: 'white',
  },
}
